import React from 'react';
import { ArraySlot } from 'react-plugin';
import styled from 'styled-components';
import { IconButton32 } from '../../components/buttons/IconButton32.js';
import { LayersIcon } from '../../components/icons/index.js';
import { NavPanelRowSlot } from '../../slots/NavPanelRowSlot.js';
import { grey32, white10 } from '../../style/colors.js';
export const NavPanel = React.memo(function NavPanel({ rendererConnected, drawerPanels, setDrawerPanels, navPanelRowOrder, globalActionOrder, onClose, }) {
    const slotProps = React.useMemo(() => ({ onCloseNavPanel: onClose }), [onClose]);
    return (React.createElement(Container, null,
        React.createElement(Content, null,
            React.createElement(NavPanelRowSlot, { slotProps: slotProps, plugOrder: navPanelRowOrder })),
        React.createElement(Separator, null),
        React.createElement(Footer, null,
            rendererConnected && (React.createElement(ArraySlot, { name: "globalAction", plugOrder: globalActionOrder })),
            React.createElement(IconButton32, { icon: React.createElement(LayersIcon, null), title: 'Toggle drawer panels', selected: drawerPanels, onClick: () => setDrawerPanels(!drawerPanels) }))));
});
const Container = styled.div `
  width: 100%;
  height: 100%;
  background: ${grey32};
  display: flex;
  flex-direction: column;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 1px;
    background: ${white10};
  }
`;
const Content = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const Footer = styled.div `
  flex-shrink: 0;
  height: 40px;
  padding: 0 4px;
  background: ${grey32};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`;
// Add 1px right gap to avoid overlapping with the nav pane right-side border
const Separator = styled.div `
  margin: 0 8px;
  height: 1px;
  background: ${white10};
`;
